import { definitionFactory } from '../definitionFactory';
import { rangeAreaStr } from '../../../utils/text';
import { onDeleteAction } from '../definitionsDeleteAction';

export const livingAreaInputDefinition = definitionFactory({
  key: 'living_area',
  mapper: ({ gte, lte }) => gte || lte ? [{
    label: rangeAreaStr('Жилая площадь', gte, lte),
    value: { gte, lte },
  }] : [],
  onDeleteAction: (value, options = {}) => {
    return onDeleteAction(value, 'living_area', options);
  },
});
